import { render, staticRenderFns } from "./UnreadChatCard.vue?vue&type=template&id=23ef1ed0&scoped=true&"
import script from "./UnreadChatCard.vue?vue&type=script&lang=ts&"
export * from "./UnreadChatCard.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadChatCard.vue?vue&type=style&index=0&id=23ef1ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef1ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
